<div class="slider d-flex flex-column align-items-center" [ngClass]="{ range: type === 'dual', single: type === 'single', disabled: isDisabled }">
    <input
        *ngIf="type === 'single'"
        class="slider-input text-center form-control"
        [ngModel]="value"
        (focusout)="onFocusOut($event)"
        (keyup.enter)="updateSlider($event)"
        (keypress)="checkSliderContent($event)"
        [disabled]="isDisabled"
        type="text"
    />
    <ngx-slider
        *ngIf="type === 'single'"
        [(value)]="value"
        [options]="options"
        (userChangeEnd)="onSliderChange($event)"
        (valueChange)="valueChange($event)"
        (keydown)="disableEventBubbling($event)"
        [manualRefresh]="manualRefresh"
    ></ngx-slider>

    <ngx-slider
        *ngIf="type === 'dual'"
        [(value)]="value"
        [options]="options"
        (userChangeEnd)="onSliderChange($event)"
        (valueChange)="rangeSliderValueChange($event)"
        (highValueChange)="rangeSliderHighValueChange($event)"
        (keydown)="disableEventBubbling($event)"
        [highValue]="highSliderValue"
        [manualRefresh]="manualRefresh"
    ></ngx-slider>
</div>
